import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";

const ContactUsFormList = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getContactFormList");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        console.log(response)
        const list = response.data.data.reverse();
        setList(list);
        setLoading(false);
      })
      .catch((error) => {
        // alert("Something Went Wrong");
      });
  }, []);
  return (
    <>
      <MaterialTable
        title="Contact Us Form"
        columns={[
          {
            title: "Date",
            field: "date",
          },
          {
            title: "Time",
            field: "time",
          },

          {
            title: "First Name",
            field: "name",
          },
          {
            title: "Last Name",
            field: "lastname",
          },

          {
            title: "Phone Number",
            field: "phoneNumber",
          },
          { title: "Subject", field: "subject" },
          { title: "Message", field: "message" }

        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
};

export default ContactUsFormList;
